import {
  SENDING_ACCOUNTS_REQUEST,
  FETCH_ACCOUNTS_SUCCESS,
  FETCH_ACCOUNTS_FAILURE,
  SENDING_ACCOUNT_UPDATE,
  UPDATE_ACCOUNT_FAILURE,
  SENDING_ACCOUNT_UPDATE_PERMISSION,
  UPDATE_ACCOUNT_PERMISSION_FAILURE,
  SENDING_ACCOUNT_DELETE,
  DELETE_ACCOUNT_FAILURE,
  SENDING_PERMISSIONS_REQUEST,
  FETCH_PERMISSIONS_SUCCESS
} from '../actions/constants'

const initialState = {
  accounts: [],
  permissions: [],
  fetching: false,
  fetchingPermissions: false,
  error: ''
}

const account = (state = initialState, action) => {
  switch (action.type) {
    case SENDING_ACCOUNTS_REQUEST:
    case SENDING_ACCOUNT_UPDATE:
    case SENDING_ACCOUNT_DELETE:
    case SENDING_ACCOUNT_UPDATE_PERMISSION:
      return {
        ...state,
        fetching: action.sending
      }
    case FETCH_ACCOUNTS_SUCCESS:
      return {
        ...state,
        accounts: action.accounts
      }
    case SENDING_PERMISSIONS_REQUEST:
      return {
        ...state,
        fetchingPermissions: action.sending
      }
    case FETCH_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissions: action.permissions
      }
    case FETCH_ACCOUNTS_FAILURE:
    case DELETE_ACCOUNT_FAILURE:
    case UPDATE_ACCOUNT_FAILURE:
    case UPDATE_ACCOUNT_PERMISSION_FAILURE:
      return {
        ...state,
        error: action.error
      }
    default:
      return state
  }
}

export default account



// WEBPACK FOOTER //
// ./src/reducers/account.js